import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import PayableIntegrationService from '../../../service/PayableIntegrationService';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import PayableIntegrationServiceModal from './PayableIntegrationServiceModal';

class PayableIntegrationServiceView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedPayable: null,
      headers: [],
      rows: [],
    };
  }

  onPayableRowSelect(row) {
    const { payables, } = this.state;
    this.setState({
      selectedPayable: payables.find(payable => payable.id === row.id),
      isOpen: true,
    });
  }

  toggleModal = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  getPayablesByCustomerId(searchFields, onCompletion) {
    this.reset();

    PayableIntegrationService.getPayablesByCustomerId(searchFields)
      .then((response) => {
        const { payables, } = response.data;
        const headers = [];
        const rows = [];
        payables.forEach((payable, index) => {
          rows.push({ value: [], });
          Object.entries(payable).filter(([ key, ]) => ![
            'paymentTransactions',
            'searchableData',
            'unsearchableData',
          ].includes(key)).forEach(([ key, value, ]) => {
            if (index === 0) {
              headers.push({
                value: key,
                display: _.startCase(key),
              });
            }
            rows[index].value.push(value);
          });
        });

        this.setState({
          headers,
          rows,
          payables,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  getPayablesBySearchFields(searchFields, onCompletion) {
    this.reset();

    PayableIntegrationService.getPayablesBySearchFields(searchFields)
      .then((response) => {
        const { payable, } = response.data;
        const headers = [];
        const rows = [ { value: [], }, ];
        Object.entries(payable).filter(([ key, ]) => ![
          'paymentTransactions',
          'searchableData',
          'unsearchableData',
        ].includes(key)).forEach(([ key, value, ]) => {
          headers.push({
            value: key,
            display: _.startCase(key),
          });
          rows[0].value.push(value);
        });

        this.setState({
          headers,
          rows,
          payables: [ payable, ],
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const { serviceOfferingId, } = this.props;

    if (combo.value === 'Customer Id') {
      this.getPayablesByCustomerId({
        customerId: search.value,
        serviceOfferingId,
      }, event.kill);
    } else {
      this.getPayablesBySearchFields({
        searchField: combo.value,
        searchFieldValue: search.value,
        serviceOfferingId,
      }, event.kill);
    }
  }

  reset() {
    this.setState({
      isOpen: false,
      selectedPayable: null,
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      headers,
      rows,
      selectedPayable,
      isOpen,
    } = this.state;

    const {
      comboFields,
    } = this.props;

    return (
        <div className='container'>
          <SearchBar
            comboFields={comboFields.map(cf => {
              return {
                value: cf.display,
                display: cf.display,
              };
            })}
            onClick={(event) => this.searchOnClick(event)}
          />
          <div style={{ marginTop: '35px', }}>
            <FieldSet title="Payables">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onPayableRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          </div>
          {selectedPayable && (
            <PayableIntegrationServiceModal
              isOpen={isOpen}
              toggleModal={this.toggleModal}
              payable={selectedPayable}
            />
          )}
        </div>
    );
  }
}

PayableIntegrationServiceView.propTypes = {
  serviceOfferingId: PropTypes.string.isRequired,
  comboFields: PropTypes.array.isRequired,
};

export default PayableIntegrationServiceView;
